import React from "react";
import { Link } from "react-router-dom";

// SVG icons for contact info (web-sourced)
const EmailIcon = (
  <svg className="w-5 h-5 md:w-6 md:h-6 text-indigo-400 inline-block mr-2" viewBox="0 0 1000 1000" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M 100 423C 100 423 100 800 100 800C 100 800 900 800 900 800C 900 800 900 423 900 423C 900 423 614 621 614 621C 614 621 614 621 614 621C 574 647 538 663 500 663C 462 663 426 647 386 621C 386 621 386 621 386 621C 386 621 100 423 100 423M 100 225C 100 225 100 362 100 362C 100 362 414 579 414 579C 449 603 475 613 500 613C 525 613 551 603 586 579C 586 579 900 362 900 362C 900 362 900 225 900 225C 900 225 100 225 100 225M 100 175C 100 175 900 175 900 175C 927 175 950 198 950 225C 950 225 950 800 950 800C 950 827 927 850 900 850C 900 850 100 850 100 850C 73 850 50 827 50 800C 50 800 50 225 50 225C 50 198 73 175 100 175C 100 175 100 175 100 175"/>
  </svg>
);
const PhoneIcon = (
  <svg className="w-5 h-5 md:w-6 md:h-6 text-green-400 inline-block mr-2" viewBox="0 0 1000 1000" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M 640 179C 640 179 640 179 640 179C 662 156 692 140 724 139C 763 140 796 169 823 195C 853 222 865 262 859 301C 847 538 676 751 455 830C 391 851 323 870 254 861C 206 844 160 809 137 763C 129 729 145 692 169 668C 210 642 258 633 303 617C 355 600 404 631 446 658C 481 651 512 619 541 595C 590 550 632 495 657 431C 623 412 587 373 597 334C 605 281 614 226 640 179" transform="rotate(90,500,500)"/>
  </svg>
);
const LocationIcon = (
  <svg style={{ width: '2.4rem', height: '2.4rem' }} className="text-pink-400 inline-block mr-2" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"/>
  </svg>
);
const HoursIcon = (
  <svg className="w-5 h-5 md:w-6 md:h-6 text-yellow-400 inline-block mr-2" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function Footer() {
  const contactInfo = [
    {
      icon: EmailIcon,
      title: "Email",
      value: "info@techadr.co",
      link: "mailto:info@techadr.co"
    },
    {
      icon: PhoneIcon,
      title: "Phone",
      value: "+91 8408993879",
      link: "tel:+918408993879"
    },
    {
      icon: LocationIcon,
      title: "Location",
      value: "Office No.11 Bld No.22, Vinayraj Regency, opp. Baithak Cafe, Boisar, Khaira, Maharashtra 401501",
      link: "https://maps.app.goo.gl/kyUfTiex3eVFVJof9"
    },
    {
      icon: HoursIcon,
      title: "Business Hours",
      value: "Mon - Fri: 9AM - 6PM",
      link: "#"
    }
  ];

  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/techadr",
      color: "hover:text-blue-500",
      icon: (
        <svg className="w-5 h-5 md:w-6 md:h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
      )
    },
    {
      name: "X (Twitter)",
      url: "https://x.com/TechAdr",
      color: "hover:text-gray-800 dark:hover:text-white",
      icon: (
        <svg className="w-5 h-5 md:w-6 md:h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
      )
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/techadr",
      color: "hover:text-blue-600",
      icon: (
        <svg className="w-5 h-5 md:w-6 md:h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
      )
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/tech.adr",
      color: "hover:text-pink-500",
      icon: (
        <svg className="w-5 h-5 md:w-6 md:h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
      )
    }
  ];

  return (
    <footer className="w-full py-10 bg-[#1b1c4e] text-white pb-24 md:pb-10">
      <div className="max-w-7xl mx-auto px-2 md:px-4">
        {/* Main Footer Content */}
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-6 md:gap-8 mb-8">
          {/* Company Info */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-3 md:mb-4">
          <img src="/TechADR-Logo-White.svg" alt="Tech ADR Logo White" className="h-8 w-auto" />
          <span className="font-bold text-lg">Tech ADR IT Solutions Pvt. Ltd.</span>
            </div>
            <p className="text-white/70 text-sm mb-3 md:mb-4">
              Transforming businesses through innovative technology solutions and strategic consulting.
            </p>
            {/* Social Media Links */}
            <div className="flex justify-center md:justify-start gap-3 md:gap-4 mb-2 md:mb-0">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-white/70 transition-colors duration-300 ${social.color}`}
                  title={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Information */}
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-lg mb-3 md:mb-4">Contact Information</h3>
            <div className="space-y-2 md:space-y-3">
              {contactInfo.map((info) => (
                <a
                  key={info.title}
                  href={info.link}
                  target={info.title === "Location" ? "_blank" : "_self"}
                  rel={info.title === "Location" ? "noopener noreferrer" : ""}
                  className="flex items-center justify-center md:justify-start gap-2 text-sm text-white/70 hover:text-white transition-colors duration-300"
                >
                  {info.icon}
                  <div>
                    <div className="font-medium text-xs md:text-sm">{info.title}</div>
                    <div className="text-xs md:text-sm whitespace-normal max-w-[180px] md:max-w-none">{info.value}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-lg mb-3 md:mb-4">Quick Links</h3>
            <div className="flex flex-col gap-1 md:gap-2 text-sm">
              <Link to="/privacy-policy" className="hover:underline opacity-80 hover:opacity-100 transition-opacity duration-300">
                Privacy Policy
              </Link>
              <Link to="/terms-and-conditions" className="hover:underline opacity-80 hover:opacity-100 transition-opacity duration-300">
                Terms & Conditions
              </Link>
              <Link to="/disclaimer" className="hover:underline opacity-80 hover:opacity-100 transition-opacity duration-300">
                Disclaimer
              </Link>
              <Link to="/refund-return" className="hover:underline opacity-80 hover:opacity-100 transition-opacity duration-300">
                Refund & Return Policy
              </Link>
            </div>
          </div>

          {/* Map */}
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-lg mb-3 md:mb-4">Our Location</h3>
            <div className="rounded-lg overflow-hidden shadow-lg">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d239977.94648669046!2d72.59066921044467!3d19.980988729019884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be71f2454f10c79%3A0x1cdff6c7c8932e97!2sTech%20ADR%20IT%20Solutions%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1752333690300!5m2!1sen!2sin" 
                width="100%" 
                height="120" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Tech ADR IT Solutions Location"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-4 md:pt-6 text-center">
          <div className="text-xs text-white/60">
            &copy; {new Date().getFullYear()} Tech ADR IT Solutions Pvt. Ltd. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
} 